import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import dayjs from "dayjs";

import { stringifyParams } from "../../../../utils/stringify";
import { agreementsAnalysisApi } from "../api";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const SET_UPDATES_LOADING = "sagas/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATES = "saga/SET_DATES";

export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_DATA_SUCCESS = "saga/FETCH_DATA_SUCCESS";

export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
export const UPDATE_DATES = "sagas/UPDATE_DATES";
export const UPDATE_DATA = "sagas/UPDATE_DATA";
export const RESET_DATA = "sagas/RESET_DATA";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateFilters: createAction(UPDATE_FILTERS),
  updateDates: createAction(UPDATE_DATES),
  resetFilters: createAction(RESET_DATA),
  updateData: createAction(UPDATE_DATA)
};

export default function* watchAgreementsAnalysis() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_DATA, updateData);
  yield takeLatest(RESET_DATA, resetData);
}

function* initModuleData() {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  yield setDates();
  yield fetchFilters();
  yield fetchData();

  yield put({ type: SET_LOADING, payload: false });
}

export function* getCurrentUserData({ payload }) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload
  });

  try {
    yield* initModuleData();
  } catch (error) {
    console.error(error);
  }
}

export function* resetData() {
  try {
    yield* initModuleData();
  } catch (error) {
    console.error(error);
  }
}

export function* setDates() {
  const endDate = yield select((state) => state.agreementsAnalysis.currentUser.calendarEndDate);

  yield put({
    type: SET_DATES,
    payload: {
      startDate: dayjs(endDate).startOf("month").format(API_DATE_FORMAT),
      endDate: endDate
    }
  });
}

function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  try {
    yield fetchData();
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchFilters() {
  const params = yield getCommonApiParams();

  try {
    const { data } = yield call(agreementsAnalysisApi.getFilters, {
      ...params
    });

    yield put({
      type: FETCH_FILTERS_SUCCESS,
      payload: data
    });
  } catch (err) {
    console.error(err);
  }
}

export function* fetchData() {
  const params = yield getCommonApiParams();

  try {
    const { data } = yield call(agreementsAnalysisApi.getData, {
      ...params
    });

    yield put({ type: FETCH_DATA_SUCCESS, payload: data });
  } catch (error) {
    console.error(error);
  }
}

export function* getCommonApiParams() {
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  const {
    selectedRequestDates: { endDate, startDate },
    selectedFilters
  } = yield select((state) => state.agreementsAnalysis);

  const filters = stringifyParams(selectedFilters);

  return {
    organization_id: organization_id.toString(),
    short_url,
    end_date: endDate,
    start_date: startDate,
    ...(Object.keys(filters).length > 0 && { filters })
  };
}
